import { ActionReducer, Action } from "@ngrx/store"
import { CalendarStore } from "@store/calendar"
import { Term } from "@models/term"
import { PublicHoliday } from "@models/public-holiday"

export const calendarReducer: ActionReducer<CalendarStore> = (state: CalendarStore = new CalendarStore(), action: Action) => {

  switch(action.type) {
    case POPULATE_EDITABLE_TERM:
      return new CalendarStore(
        [...state.terms],
        Term.clone(action.payload),
        PublicHoliday.clone(state.editablePublicHoliday),
        state.activeDay)

    case POPULATE_EDITABLE_PUBLIC_HOLIDAY:
      return new CalendarStore(
        [...state.terms],
        Term.clone(state.editableTerm),
        PublicHoliday.clone(action.payload),
        state.activeDay)

    case POPULATE_ACTIVE_DAY:
      return new CalendarStore(
        [...state.terms],
        Term.clone(state.editableTerm),
        PublicHoliday.clone(state.editablePublicHoliday),
        action.payload)

    case POPULATE_CALENDAR_TERMS:
      return new CalendarStore(
        action.payload,
        Term.clone(state.editableTerm),
        PublicHoliday.clone(state.editablePublicHoliday),
        action.payload)

    default:
      return state
  }
}

export const FETCH_CALENDAR_TERMS = "FETCH_CALENDAR_TERMS"
export const FETCH_CALENDAR_TERMS_FAILURE = "FETCH_CALENDAR_TERMS_FAILURE"
export const POPULATE_CALENDAR_TERMS = "POPULATE_CALENDAR_TERMS"
export const POPULATE_ACTIVE_DAY = "POPULATE_ACTIVE_DAY"
export const POPULATE_EDITABLE_TERM = "POPULATE_EDITABLE_TERM"
export const POPULATE_EDITABLE_PUBLIC_HOLIDAY = "POPULATE_EDITABLE_PUBLIC_HOLIDAY"
export const UPDATE_TERM = "UPDATE_TERM"
export const UPDATE_TERM_FAILURE = "UPDATE_TERM_FAILURE"
export const CREATE_TERM = "CREATE_TERM"
export const CREATE_TERM_FAILURE = "CREATE_TERM_FAILURE"
export const UPDATE_PUBLIC_HOLIDAY = "UPDATE_PUBLIC_HOLIDAY"
export const UPDATE_PUBLIC_HOLIDAY_FAILURE = "UPDATE_PUBLIC_HOLIDAY_FAILURE"
export const CREATE_PUBLIC_HOLIDAY = "CREATE_PUBLIC_HOLIDAY"
export const CREATE_PUBLIC_HOLIDAY_FAILURE = "CREATE_PUBLIC_HOLIDAY_FAILURE"
export const DESTROY_PUBLIC_HOLIDAY = "DESTROY_PUBLIC_HOLIDAY"
export const DESTROY_PUBLIC_HOLIDAY_FAILURE = "DESTROY_PUBLIC_HOLIDAY_FAILURE"



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/calendar.ts